import { createActionType } from "Common/namespaceUtils/namespaceRedux";
import { FULL_NAMESPACE } from "../constants";
export default {
    GET_WORK_SPACES: createActionType(FULL_NAMESPACE, "GET_WORK_SPACES"),
    GET_WORK_SPACES_COMPLETED: createActionType(FULL_NAMESPACE, "GET_WORK_SPACES_COMPLETED")
};
